'use client';

import { c as _c } from "react/compiler-runtime";
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { cn } from '@/lib/utils';
const Popover = PopoverPrimitive.Root;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverContent = React.forwardRef<React.ElementRef<typeof PopoverPrimitive.Content>, React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
  portalContainer?: HTMLElement | null;
}>((t0, ref) => {
  const $ = _c(19);
  let children;
  let className;
  let portalContainer;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      className,
      align: t1,
      sideOffset: t2,
      portalContainer,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = portalContainer;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    className = $[2];
    portalContainer = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  let t3;
  if ($[7] !== className) {
    t3 = cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-navigation origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-none", className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== align || $[10] !== children || $[11] !== props || $[12] !== ref || $[13] !== sideOffset || $[14] !== t3) {
    t4 = <PopoverPrimitive.Content ref={ref} align={align} sideOffset={sideOffset} className={t3} {...props}>{children}</PopoverPrimitive.Content>;
    $[9] = align;
    $[10] = children;
    $[11] = props;
    $[12] = ref;
    $[13] = sideOffset;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== portalContainer || $[17] !== t4) {
    t5 = <PopoverPrimitive.Portal container={portalContainer}>{t4}</PopoverPrimitive.Portal>;
    $[16] = portalContainer;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };